import useToken from 'hooks/useToken';
import React, { useEffect } from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import Greetings from './Greeting/Greetings.js';
import TotalAnualByMonth from './TotalAnualByMonth.js';
import VentasPorVendedor from './VentasPorVendedor.js';
import SalesByCategory from './SalesByCategory.js';
import SalesBySeller from './SalesBySeller.js';
import SalesDashboard from './GraficasVentas.js';
import ErrorBoundary from 'components/common/ErrorBoundary';
import SalesLineChart from 'akasia-components/marketing/dashboard/components/SalesLineChart.js';
import SellerComparisonChart from 'akasia-components/marketing/dashboard/components/SellerComparisonChart.js';

const AdministradoresReporteVentas = () => {

    const { token, idCatTipoUsuario } = useToken();
    const navigate = useNavigate();
    const { showErrorToast } = useToast();

    /**
     * Se ejecuta la primera vez
     */
    useEffect(() => {

        if (idCatTipoUsuario != 1) {
            navigate("/");
        }

        checkPermisos();

    }, []);

    /**
     * Verifica los permisos
     */
    const checkPermisos = async () => {

        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                //                
            } else {
                navigate("/");
            }

        }
        else {
            navigate("/");
        }
    }


    return (
        <>
            <Row className="">

                <Col className="col-12 mb-3">
                    <Greetings />
                </Col>

                <Col className="col-12 mb-3">
                    <ErrorBoundary>
                        <TotalAnualByMonth />
                    </ErrorBoundary>

                </Col>

                <Col className="col-12 mb-3">
                    <ErrorBoundary>

                        <VentasPorVendedor
                            items_Money={"MONEY"}
                            />
                    </ErrorBoundary>

                </Col>
            </Row>
            <Row>
                <Col md={12} className="mb-3">
                    <ErrorBoundary>
                        <SalesDashboard />
                    </ErrorBoundary>


                </Col>


            </Row>
            <Row className="g-3 mt-3">
                <Col xs={12}>
                    <ErrorBoundary>
                        <SalesLineChart />
                    </ErrorBoundary>
                </Col>
            </Row>

            <Row className="g-3 mt-3">
                <Col xs={12}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Monthly Sales Volume per Sale Agent</Card.Title>
                            <SellerComparisonChart />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <ErrorBoundary>

                        <SalesByCategory />
                    </ErrorBoundary>

                </Col>

                <Col>
                    <ErrorBoundary>

                        <SalesBySeller />
                    </ErrorBoundary>

                </Col>
            </Row>
        </>
    );
};

export default AdministradoresReporteVentas;
